import Administrators from './administrators'
import NonAdministrators from './non_administrators'
import PrincipalDocument from './principal_document'
import TeacherDocument from './teacher_document'

export default { Administrators, NonAdministrators, PrincipalDocument, TeacherDocument }
